
export enum GlobalMutationTypes {
    SET_LOADING = 'SET_LOADING',
    SET_COMPONENT_LOADING = 'SET_COMPONENT_LOADING',
    SET_PLATFORM = 'SET_PLATFORM',
    SET_SALECHANNEL = 'SET_SALECHANNEL',
    SET_IS_IN_PRODUCT_DETAIL = 'SET_IS_IN_PRODUCT_DETAIL',
    SET_SESSION_ID = 'SET_SESSION_ID'
}
